import { Component, OnInit } from '@angular/core';

import { NewsService } from '../../services/newsService'
@Component({
  selector: 'app-detail-news',
  templateUrl: './detail-news.component.html',
  styleUrls: ['./detail-news.component.css']
})
export class DetailNewsComponent implements OnInit {

  news: any[] = [];
  Promotion:any[] = [];
  private Checktoggle: boolean = true;
  constructor(private newss: NewsService) { }

  ngOnInit() {
    let newsTemp = this.newss.getNewsShow()
    newsTemp.subscribe((snap) => {
      //console.log(snap)
      for (var i = 0; i < snap.length; i++) {
        if (snap[i].type == '1') {
          this.news.push(snap[i])
          //console.log(snap[i])
        }
      }
    })

    let PromotionTemp = this.newss.getNewsShow()
    PromotionTemp.subscribe((snap) => {
      //console.log(snap)
      for (var i = 0; i < snap.length; i++) {
        if (snap[i].type == '2') {
          this.Promotion.push(snap[i])
          //console.log(snap[i])
        }
      }
    })
  }
  toggle(change: string) {
    if (change === 'news') {
      this.Checktoggle = true;
    } else {
      this.Checktoggle = false;
    }
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-news/detail-news.component.ts